import { render, staticRenderFns } from "./orderMail.vue?vue&type=template&id=27caaa9c&scoped=true&"
import script from "./orderMail.vue?vue&type=script&lang=js&"
export * from "./orderMail.vue?vue&type=script&lang=js&"
import style0 from "./orderMail.vue?vue&type=style&index=0&id=27caaa9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27caaa9c",
  null
  
)

export default component.exports